// Budowa uporzadkowanej listy materialow (wideo/PDF) z odpowiedzi `GET {apiUrl}{trainingId}`.
// Wspolna dla trybu logowania pracownika (`Training.js`) i stanowiska rejestracyjnego
// (`RegistrationStation.js`) — TA SAMA funkcja, zeby obie sciezki nie mogly sie rozjechac.
// Nowy backend wysyla uporzadkowana tablice `materials` (wideo + PDF, w kolejnosci ustawionej
// przez admina); starszy backend wysyla tylko pojedynczy obiekt `pdf` — fallback na niego, zeby
// odtwarzacz dzialal takze przed wdrozeniem nowego backendu.
export const getMaterialsFromCourseData = (courseData) => {
  if (!courseData) {
    return [];
  }
  if (Array.isArray(courseData.materials)) {
    return courseData.materials.filter((material) => material && material.url);
  }
  if (courseData.pdf && courseData.pdf.url) {
    return [courseData.pdf];
  }
  return [];
};
